/**
 * [小运力公司钱包列表]
 * @author: Sun yue
 * @date: 2022-07-28
 */

import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import moment from 'moment';
import { XInput, XSelect, XDatePicker, XOKButton, XCancelButton, XTabNav } from '@/components/xqxc_ui';
import { SearchBox, SearchItem } from '@/components/Layout';
import { message, Modal } from 'antd';
import * as apis from '@/apis/finance/transportCompanyWallet';
import { getEnum } from '@/apis/common/index';
import { regFenToYuan } from '@/util/money';
import TableList from './components/TableList';
import DetailModal from './modal/detailModal';
import getEnumData from '@/helpers/getEnumData';

const { confirm } = Modal;

function TransportCompanyWallet(props) {
  const page = useRef({ pageSize: 10, pageNum: 1 });

  const [reset, setReset] = useState();

  const [transportName, setTransportName] = useState()
  const [transportStatusEnum, setTransportStatusEnum] = useState([])
  const [transportStatus, setTransportStatus] = useState({})
  const [listData, setListData] = useState({});

  const [detailVisible, setDetailVisible] = useState(false)
  const [detailInfo, setDetailInfo] = useState({})

  useEffect(() => {
    props.setBreadcrumbPaths(props.match);
    onSearch();

    getEnumData('SmallTransportStatusEnum', (res) => {
      res.forEach(val => {
        val.value
      })
      setTransportStatusEnum(res)
    })
  }, []);

  useEffect(() => {
    reset && onSearch();
  }, [reset]);

  const onSearch = () => {
    let params = {
      transportName,
      status: transportStatus.code,
      pageSize: page.current.pageSize,
      pageNum: page.current.pageNum,
    };

    apis.getTransportCompanyWalletList(params).then(res => {
      setListData(res.result);
    }).catch(err => {
      message.error(err.message);
    });
  };

  const onReset = () => {
    setTransportName()
    setTransportStatus({})
    setReset(Date.now());
    page.current = { pageNum: 1, pageSize: 10 };
  };

  const onSearchHandle = () => {
    page.current = { pageNum: 1, pageSize: 10 };
    onSearch();
  };

  const onPageChange = (pageSize, pageNum) => {
    page.current = { pageNum, pageSize };
    onSearch();
  };

  const tableAction = (type, item) => {
    switch (type) {
      case 'detail':
        setDetailVisible(true)
        getTransportCompanyDetail(item.id)
        break;
      case 'accountDetail':
        props.history.push('/home/finance/transportCompanyWallet/accountDetail/' + item.id)
        break;
      case 'cashRecord':
        props.history.push('/home/finance/transportCompanyWallet/cashRecord/' + item.id)
        break;
      default:
      // nothing to do
    }
  };

  //获取小运力钱包详情
  const getTransportCompanyDetail = (id) => {
    apis.getTransportCompanyWalletDetail({ id }).then(res => {
      setDetailInfo(res.result)
    })
  }

  return (
    <div className={styles.flexBoxContainer}>
      <SearchBox>
        <SearchItem>
          <XInput
            allowClear={true}
            label='小运力公司名称：'
            placeholder='请输入小运力公司名称'
            value={transportName}
            bindThis={setTransportName}
            bindName='transportName'
          />
        </SearchItem>
        <SearchItem>
          <XSelect
            allowClear={true}
            label='状态：'
            placeholder='请选择'
            renderData={transportStatusEnum}
            dataIndex='value'
            keyIndex='code'
            value={transportStatus.value}
            showSearch={true}
            bindThis={setTransportStatus}
            bindName='transportStatus'
          />
        </SearchItem>
        <SearchItem>
          <XOKButton
            label='查询'
            onClick={onSearchHandle}
          />
          <XCancelButton
            label='重置'
            onClick={onReset}
          />
        </SearchItem>
        <div style={{ height: 0, clear: 'both' }}></div>
      </SearchBox>
      <TableList renderData={listData} tableAction={tableAction} paginationChange={onPageChange} />

      {detailVisible ? <DetailModal closeMode={() => setDetailVisible(false)} detailInfo={detailInfo}></DetailModal> : null}
    </div>
  );
}

TransportCompanyWallet.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object,
  setBreadcrumbPaths: PropTypes.func
};

export default connect(null, { setBreadcrumbPaths })(TransportCompanyWallet);